import { render } from "./index.vue?vue&type=template&id=38e2ccb6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script